import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const parseTimestampToSeconds = (timestamp: string): number => {
  const parts = timestamp.split(":").map(Number);

  if (parts.length === 2) {
    // MM:SS format
    return parts[0] * 60 + parts[1];
  } else if (parts.length === 3) {
    // HH:MM:SS format
    return parts[0] * 3600 + parts[1] * 60 + parts[2];
  }

  return 0;
};

export const parseContentWithTimestamps = (
  content: string,
  onTimestampClick: (timestamp: number) => void,
) => {
  const timestampRegex = /\b(\d{1,2}:\d{2}(?::\d{2})?(?:\.\d{3})?)\b/g;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = timestampRegex.exec(content)) !== null) {
    if (match.index > lastIndex) {
      parts.push(content.slice(lastIndex, match.index));
    }

    const timestampStr = match[1];
    const timestampSeconds = parseTimestampToSeconds(timestampStr);

    parts.push(
      <button
        key={`${match.index}-${timestampStr}`}
        className={cn(buttonVariants({ variant: "link" }), "p-0")}
        onClick={() => onTimestampClick(timestampSeconds)}
        type="button"
      >
        {timestampStr}
      </button>,
    );

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < content.length) {
    parts.push(content.slice(lastIndex));
  }

  return parts.length > 1 ? parts : [content];
};
